import { PricingView } from "~landing/views/pricing";
import { NextPage } from "next";
import { MarketingSeo } from "~landing/seo/marketing-seo";
import { useEffect } from "react";
import { sendPricingPageViewEvent } from "~tag-manager/send-event";

const PricingPage: NextPage = () => {
	useEffect(() => {
		sendPricingPageViewEvent();
	}, []);

	return (
		<>
			<MarketingSeo
				path="/pricing"
				title="Pricing"
				description="Start for free with a no-obligation free trial account."
			/>
			<PricingView />
		</>
	);
};

export default PricingPage;
